import { render, staticRenderFns } from "./IndicadoresPagination.vue?vue&type=template&id=dd1a3aa2&"
import script from "./IndicadoresPagination.vue?vue&type=script&lang=js&"
export * from "./IndicadoresPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports